// pointValues.jsx
// Loads the point-value CSV. Cache-busted so CSV edits are picked up
// immediately on the next page load, without needing a hard refresh.

export async function loadPointValues() {
  const res = await fetch(`/data/point_values.csv?t=${Date.now()}`, {
    cache: "no-store",
  });
  const text = await res.text();

  const lines = text.split("\n").map((l) => l.trim()).filter(Boolean);
  const map = {};

  lines.forEach((line) => {
    const parts = line.split(",").map((p) => p.trim());
    if (parts.length < 3) return; // need key, id, weight

    const [rawKey, rawId, rawVal] = parts;

    // Skip rows with no usable key
    if (!rawKey || !/^[a-zA-Z0-9_.]+$/.test(rawKey)) return;

    const num = Number(rawVal);
    if (!rawVal || isNaN(num)) return; // skip rows with no usable value

    map[rawKey] = { id: rawId || "", weight: num };
  });

  return map;
}